module.exports = __webpack_public_path__ + "img/horizontal_4_4_9005.40745ddc.png";